import { types } from "../../types/types";

const initialState = {
  loading: false,
  dataContrato: null,
  presupuesto: null,
  matriculasMedicas: [],
  motivosBaja: [],
  nomencladores: [],
  trackingPresupuesto: [],
  acuerdoJudicial: false
};

export const contratacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesTraerPorCUITStart:
      return {
        ...state,
        loading: true,
      };
    case types.contratacionesTraerPorCUITSuccess:
      return {
        ...state,
        dataContrato: action.payload,
        loading: false,
      };
    case types.contratacionesTraerPorCUITError:
      return {
        ...state,
        dataContrato: null,
        loading: false,
      };
    case types.contratacionesSetDataContrato:
      return {
        ...state,
        dataContrato: action.payload,
      };
    case types.contratacionesPrespuestoXidTraerStart:
      return {
        ...state,
        loading: true,
      };
    case types.contratacionesPrespuestoXidSetear:
      return {
        ...state,
        presupuesto: action.payload,
        loading: false,
      };
    case types.contratacionesPrespuestoXidTraerError:
      return {
        ...state,
        presupuesto: null,
        loading: false,
      };
    case types.contratacionesMatriculasMedicasTraerStart:
      return {
        ...state,
        loading: true,
      };
    case types.contratacionesMatriculasMedicasTraerSuccess:
      return {
        ...state,
        matriculasMedicas: action.payload,
        loading: false,
      };
    case types.contratacionesMatriculasMedicasTraerError:
      return {
        ...state,
        matriculasMedicas: [],
        loading: false,
      };
    case types.contratacionesMotivosBajaTraerStart:
      return {
        ...state,
        loading: true,
      };
    case types.contratacionesMotivosBajaTraerSuccess:
      return {
        ...state,
        motivosBaja: action.payload,
        loading: false,
      };
    case types.contratacionesMotivosBajaTraerError:
      return {
        ...state,
        motivosBaja: [],
        loading: false,
      };
    case types.contratacionesNomencladorTraerStart:
      return {
        ...state,
        loading: true,
      };
    case types.contratacionesNomencladorTraerSuccess:
      return {
        ...state,
        nomencladores: action.payload,
        loading: false,
      };
    case types.contratacionesNomencladorTraerError:
      return {
        ...state,
        nomencladores: [],
        loading: false,
      };
    case types.contratacionesGuardarContrato:
      return {
        ...state,
        dataContrato: action.payload,
      };
    case types.contratacionesContratoLimpiarSeleccion: {
      return {
        ...state,
        dataContrato: null,
      };
    }
    case types.contratacionesPrespuestoXidClean: {
      return {
        ...state,
        presupuesto: null,
      };
    }
    case types.contratacionesGetTrackingPresupuestoSuccess:
      return {
        ...state,
        trackingPresupuesto: action.payload,
      }
    case types.contratacionesGetTrackingPresupuestoError:
      return {
        ...state,
        trackingPresupuesto: [],
      }
    case types.contratacionesAcuerdoJudicialSet:
      return {
        ...state,
        acuerdoJudicial: action.payload,
      }
    default:
      return state;
  }
};

export const contratacionesActions = {
  acuerdoJudicial: (data) => ({ type: types.contratacionesAcuerdoJudicialSet, payload: data })
}
